
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-cars/[slug]",
      function () {
        return require("private-next-pages/electric-cars/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-cars/[slug]"])
      });
    }
  